import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-287" data-mp="mz5y1ndih8kh">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-288" data-mp="rubp10lrtdff">
        <FadeIn data-id="element-289" data-mp="wqjzw1sxqkgs">
          <div className="space-y-2 md:space-y-4" data-id="element-290" data-mp="wt67u2jqn1zj">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandViolet font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandViolet/40" data-id="element-291" data-mp="3va0nvm3gjo4o">
              <span className="text-sm md:text-base" data-id="element-292" data-mp="93u1dafsp80x">🔮</span>
              <span className="text-[8.5px]" data-id="element-293" data-mp="e1vhpnlu6t8p">
                BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS CHAKRAS™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[26px] md:text-[52px] leading-[1.1] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-294" data-mp="1kj8we8og1pte">
              TODO LO QUE NECESITAS PARA{' '}
              <span className="text-brandViolet" data-id="element-295" data-mp="1h87ud2kob28l">PROFUNDIZAR TU PRÁCTICA</span>
              <br data-id="element-296" data-mp="1cbr0rsupfvo4" />
              <span data-id="element-297" data-mp="1c94udwjjvm7h">ORGANIZADO. DESDE HOY.</span>
            </h1>
            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-298" data-mp="188b1spv5xj89">
              6 Módulos · Afirmaciones · Meditaciones · Rituales · Herramientas
              listas
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-299" data-mp="tk7wlioy2bki">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-300" data-mp="tjy5tsw2s0dr">
            <div className="absolute inset-0 bg-brandViolet/20 blur-[40px] rounded-full" data-id="element-301" data-mp="ol4yki7dt5m1"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandIndigo-electric/20 blur-[28px] rounded-full" data-id="element-302" data-mp="kkl3rlaa6e32"></div>
            <img src="https://cdn.magicpatterns.com/uploads/aiAoxphTtZMJYC7JTizVDH/Mockup_stiker.png" alt="Biblioteca Maestra del Código de los Chakras — Mockup completo del producto" loading="eager" decoding="async" className="relative block w-full max-w-[280px] md:max-w-[540px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-303" data-mp="fjx2m6sc8gv4" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-304" data-mp="3s5m0f2uudtt8">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-305" data-mp="3s4t3suplkkot">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-306" data-mp="jr3our5ozw4v">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-307" data-mp="opx00cxibb1v">
                <span className="text-[10px] md:text-xs" data-id="element-308" data-mp="evoazz7oq08g">📄</span> 100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-309" data-mp="12liqkoje22we">
                <span className="text-[10px] md:text-xs" data-id="element-310" data-mp="2s2e8sd8eg6ky">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-311" data-mp="31uajcnro9p62">
                <span className="text-[10px] md:text-xs" data-id="element-312" data-mp="295muyjbmmjoa">📚</span> 475 páginas
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-313" data-mp="248mjttzx6qqb">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-314" data-mp="2i72tntt2wxco">
                💜 QUIERO LA BIBLIOTECA AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-315" data-mp="3tjwverfhw7j0">
                <span className="flex items-center gap-1" data-id="element-316" data-mp="op6ub6an9ptu">
                  <ShieldCheck size={11} className="text-success" data-id="element-317" data-mp="oqq9etkkduu1" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-318" data-mp="xplgs8zchayx">
                  <Lock size={11} className="text-txt-muted" data-id="element-319" data-mp="xo0m8jd15s12" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-320" data-mp="12q9hxnhaf86v">
                  <CreditCard size={11} className="text-brandViolet" data-id="element-321" data-mp="17ob0m7asx5ht" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-322" data-mp="1lf6clsglk2pm">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-323" data-mp="1leo7e6byie5k">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-324" data-mp="1qeizuebdrbsq">
          <FadeIn delay={0.1} data-id="element-325" data-mp="1vd3yi9azhnf2">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandViolet mb-0.5" data-id="element-326" data-mp="1vef2a94fiv66">
              +300
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-327" data-mp="3awbdejobpb9u">
              terapeutas confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-328" data-mp="35wf9ekfmljua">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandViolet mb-0.5" data-id="element-329" data-mp="35xqjf1znzntu">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-330" data-mp="2h1efkfqcm6a">
              Módulos listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-331" data-mp="3to44u9nquofg">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandViolet mb-0.5" data-id="element-332" data-mp="3tow0fkhccm5q">
              5
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-333" data-mp="3jxrkahfxiv9b">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-334" data-mp="l8kepjiddm4m">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandViolet mb-0.5" data-id="element-335" data-mp="gg9gcl3a28e6">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-336" data-mp="2apg2rou2ak13">
              calificación <Star size={12} className="fill-gold text-gold" data-id="element-337" data-mp="2fmeqnpn4tuqu" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Por fin tengo todo en un solo lugar. Me ahorró años de búsqueda dispersa. Muy recomendable.',
    author: 'Marcela R.',
    role: 'Terapeuta Holística · México',
    bg: 'bg-brandViolet'
  }, {
    initials: 'CP',
    text: 'Tenía dudas antes de comprarlo, pero me sorprendió. Cada módulo conecta con el siguiente perfectamente.',
    author: 'Carolina P.',
    role: 'Practicante de Reiki · Colombia',
    bg: 'bg-brandIndigo-electric'
  }, {
    initials: 'DG',
    text: 'Mis sesiones cambiaron por completo. Entro con estructura y herramientas listas para aplicar.',
    author: 'Diego G.',
    role: 'Facilitador de Bienestar · Perú',
    bg: 'bg-brandViolet'
  }];
  return <Section className="bg-bg-base" data-id="element-338" data-mp="10r6frlmr2yhs">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-339" data-mp="10o0smbxom6op">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-340" data-mp="1fgugakn3xt4g" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-341" data-mp="1anjc6r9ojqg8">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-342" data-mp="1ohsmn9l0qcq7">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-343" data-mp="1jftm07gnxtwy">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-344" data-mp="3zl4mka805dp">
                  <div className="flex text-gold mb-0.5" data-id="element-345" data-mp="40ealj1cuqus">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-346" data-mp="3v808sw5b2149" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-347" data-mp="39b5nm7f2lf3i">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-348" data-mp="3j3bgdjd5c0jr">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-349" data-mp="2qexdap77ae1c">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Aprendiste sobre chakras en un lugar, sobre cristales en otro y sobre meditación en otro más', 'No tienes un sistema único donde todo esté organizado y conectado', 'Repites los mismos recursos porque no tienes un banco de técnicas más amplio', 'Un consultante nuevo llega y no sabes exactamente qué herramienta usar en el momento', 'Quieres profundizar tu práctica pero no encuentras material organizado para hacerlo', 'Sientes que tus conocimientos básicos ya no alcanzan para dar un salto real', 'Fin de semana buscando información y vuelves a empezar el mismo ciclo'];
  return <Section className="bg-bg-alt" data-id="element-350" data-mp="1qf3ota18x41k">
      <div className="max-w-[720px] mx-auto" data-id="element-351" data-mp="1qe22uaioyx52">
        <FadeIn data-id="element-352" data-mp="1lfqs7xkkoils">
          <h2 className="font-display font-extrabold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25]" data-id="element-353" data-mp="1lgabpipvff1x">
            Si eres{' '}
            <span className="text-brandViolet" data-id="element-354" data-mp="1cej428brsy5f">terapeuta energético,</span>
            <br data-id="element-355" data-mp="1cgnaawx5698v" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-356" data-mp="17h0vwk5kumyh">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-357" data-mp="36s21zj9pqir9" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-358" data-mp="iabtcsawgqdb" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-359" data-mp="ddd0se6vwrh8">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Neon divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #8B5CF6 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(139,92,246,0.8), 0 0 24px rgba(139,92,246,0.5)'
        }} data-id="element-360" data-mp="mejj8st3gcd4"></div>

          <h3 className="font-display font-extrabold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2]" data-id="element-361" data-mp="3m8lteh7l6me">
            ¿Sigues trabajando con{' '}
            <span className="text-brandViolet inline-block" style={{
            textShadow: '0 0 20px rgba(139,92,246,0.6), 0 0 40px rgba(139,92,246,0.4)'
          }} data-id="element-362" data-mp="373qqxe5ljzj4">
              conocimientos dispersos?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-363" data-mp="1dl9yyczclxol">
            <p data-id="element-364" data-mp="1ij1pb2kchbqo">
              Elegiste este camino porque amas el trabajo energético y acompañar
              a tus consultantes.
            </p>
            <p data-id="element-365" data-mp="267b6tsaizdc0">
              Pero nadie te dijo que ibas a perder tiempo buscando herramientas
              que no conectan entre sí, estructurando sesiones a último momento
              y sintiendo que te falta algo para llegar al siguiente nivel.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandViolet rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(139,92,246,0.25)]" data-id="element-366" data-mp="kwcmiqhtiv3r">
            <p className="font-display font-extrabold text-[17px] md:text-[24px] leading-[1.3] text-center text-txt-primary" data-id="element-367" data-mp="pwh30giq7ptz">
              ¿Y SI ESTA FUERA LA{' '}
              <span className="text-brandViolet" data-id="element-368" data-mp="1siuuxsqsdc2">ÚLTIMA VEZ</span>
              <br data-id="element-369" data-mp="3t5vmqmx07jip" />
              QUE BUSCAS HERRAMIENTAS DISPERSAS?
            </p>
          </div>

          {/* Neon divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14" style={{
          background: 'linear-gradient(90deg, transparent 0%, #8B5CF6 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(139,92,246,0.8), 0 0 24px rgba(139,92,246,0.5)'
        }} data-id="element-370" data-mp="3o6iypyuec6ej"></div>
        </FadeIn>
      </div>
    </Section>;
};